import type WhiteboardController from '../controllers/WhiteboardController';
import SelectField from './SelectField';
import { type SelectOptionData } from './SelectOption';
import TextField from './TextField';

const FIELD_TYPES = {
  SelectField,
  TextField,
};

export const commonSerializedKeys = [
  'id',
  'name',
  'type',
  'internal',
  'hidden',
];

export type FieldType = keyof typeof FIELD_TYPES;

export interface BaseSerializedField {
  id?: string;
  type: FieldType;
  name: string;
  internal?: boolean;
  hidden?: boolean;

  // SelectField values
  tags?: boolean;
  editable?: boolean;
}

export interface SerializedTextField extends BaseSerializedField {
  type: 'TextField';
}
export interface SerializedSelectField extends BaseSerializedField {
  type: 'SelectField';
  optionsData?: Record<string, SelectOptionData>;
}

export type SerializedField = SerializedTextField | SerializedSelectField;

export function fieldFromJSON(
  data: SerializedField & { controller: WhiteboardController }
) {
  const FieldClass = FIELD_TYPES[data.type];

  if (!FieldClass) {
    throw new Error(`Invalid field type: ${data.type}`);
  }

  return new FieldClass(data);
}
